import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section
      className="relative flex min-h-[600px] w-full items-center justify-center overflow-hidden"
      aria-label="动漫网 首页横幅"
    >
      {/* 背景图 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylish%20cinematic%20anime%20key%20visual%20of%20various%20anime%20characters%20floating%20in%20the%20sky%20among%20glowing%20sakura%20petals%2C%20cherry%20blossoms%2C%20and%20swirling%20magical%20energy%2C%20a%20massive%20warm%20setting%20sun%20with%20golden%20coral%20orange%20rays%2C%20distant%20silhouette%20of%20a%20modern%20city%20and%20anime%20tower%2C%20warm%20coral%20orange%20and%20teal%20green%20color%20palette%2C%20clean%20balanced%20composition%2C%20epic%20dreamy%20atmosphere%2C%20high%20detail%20digital%20illustration%2C%20professional%20anime%20poster%20art&width=1600&height=900&seq=anime-hero-2026&orientation=landscape"
          alt="动漫网 二次元资源聚合站背景"
          className="h-full w-full object-cover object-top"
        />
      </div>
      {/* 深色遮罩 */}
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70"></div>

      {/* 内容 */}
      <div className="relative z-10 flex w-full flex-col items-center px-4 py-24 text-center">
        <span className="rounded-full bg-background-50/15 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur">
          <i className="ri-fire-fill mr-1 text-secondary-400" aria-hidden="true"></i>
          {t('hero_badge')}
        </span>
        <h1 className="mt-5 max-w-3xl font-heading text-4xl leading-tight text-background-50 md:text-6xl">
          {t('hero_title_1')}
          <span className="text-secondary-400"> {t('hero_title_2')}</span>
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-50/85 md:text-lg">
          {t('hero_subtitle')}
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/category/ri"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
          >
            {t('hero_cta_primary')}
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
          <Link
            to="/category/ri"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50/15 px-7 py-3 text-sm font-semibold text-background-50 backdrop-blur transition hover:bg-background-50/25"
          >
            <i className="ri-movie-2-line" aria-hidden="true"></i>
            {t('hero_cta_secondary')}
          </Link>
        </div>

        {/* 数据统计 */}
        <dl className="mt-12 flex flex-wrap items-center justify-center gap-8 md:gap-12">
          {[
            { value: '12,000+', label: t('hero_stat_works') },
            { value: '380 万', label: t('hero_stat_members') },
            { value: '860+', label: t('hero_stat_tags') },
          ].map((s) => (
            <div key={s.label} className="flex flex-col items-center">
              <dt className="text-3xl font-bold text-background-50">{s.value}</dt>
              <dd className="mt-1 text-sm text-background-50/75">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}